'use client';

import Script from "next/script";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function ConditionalJotFormAgent() {
    const pathname = usePathname();

    // Cek apakah path saat ini adalah halaman muna-assistant
    const isMunaAssistantPage = pathname.includes('/muna-assistant');

    // Fungsi untuk menghapus widget JotForm jika sudah dimuat pada halaman muna-assistant
    useEffect(() => {
        if (isMunaAssistantPage) {
            // Cari dan hapus elemen JotForm agent yang mungkin sudah dimuat
            const removeJotFormElements = () => {
                // Cari berbagai kemungkinan elemen JotForm agent
                const jotFormElements = document.querySelectorAll('[id*="jotform"], [class*="jotform"], [data-jotform]');
                jotFormElements.forEach(element => {
                    element.remove();
                });

                // Hapus script JotForm yang mungkin sudah dimuat
                const jotFormScripts = document.querySelectorAll('script[src*="jotfor.ms"]');
                jotFormScripts.forEach(script => {
                    script.remove();
                });
            };

            // Hapus segera jika ada
            removeJotFormElements();

            // Tambahkan observer untuk menghapus jika dimuat secara asinkron
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.addedNodes.length) {
                        const jotFormElement = document.querySelector('[id*="jotform"], [class*="jotform"]');
                        if (jotFormElement) {
                            jotFormElement.remove();
                            observer.disconnect();
                            break;
                        }
                    }
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });

            return () => {
                observer.disconnect();
            };
        }
    }, [isMunaAssistantPage]);

    // Jangan render script jika berada di halaman muna-assistant
    if (isMunaAssistantPage) {
        return null;
    }

    // Render script JotForm Agent untuk halaman lain
    return (
        <>
            <Script
                src="https://cdn.jotfor.ms/agent/embedjs/01970aa2924175a1b0bdc07a27e22a278498/embed.js?skipWelcome=1&maximizable=1"
                strategy="afterInteractive"
                id="jotform-agent"
            />
        </>
    );
}